var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticStyle:{"font-size":"14px"},attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"text":_vm.text,"size":"big","color":"green","radius":"12px"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }